export default __webpack_public_path__ + "static/blue-skye-bdfbae60471a6d9481bb26fdba0356d8.png";